import { TEST_DIRECTORY_ID, ZOCDOC_DIRECTORY_ID } from '../constants';

export default function isZocdocBrand(directoryId) {
    return directoryId === ZOCDOC_DIRECTORY_ID || directoryId === TEST_DIRECTORY_ID;
}
